import { render, staticRenderFns } from "./BudgetList.vue?vue&type=template&id=fc19b472&scoped=true"
import script from "./BudgetList.vue?vue&type=script&lang=js"
export * from "./BudgetList.vue?vue&type=script&lang=js"
import style0 from "./BudgetList.vue?vue&type=style&index=0&id=fc19b472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc19b472",
  null
  
)

export default component.exports